<template>
  <div style="position:relative;overflow:visible">
    <ws-chip v-model="reportAt" :is-disabled="isDisabled" ></ws-chip>
    <div v-if="badge" class="update-badge">{{badge}}</div>
  </div>
</template>
<script>
import dateTimeMixin from '@/mixins/dateTimeMixin';
import WsChip from '@/modules/customerVbzWorksheet/components/WsChip.vue';
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name: 'ReportedAtTime',
  components: { WsChip },
  mixins: [dateTimeMixin,wsMixin],
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    isDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      badgeText: null
    }
  },
  computed: {
    reportAt() {
      return this.mx_reportedAtTime(this.absence);
    },
    badge(){
      if (this.absence._created) return 'new';
      if (this.absence._updated) return 'updated';

      return null;
    }
  },

};
</script>
<style scoped>
.update-badge{
  position:absolute;
  top:-6px;
  right:-4px;
  z-index:10000;
  padding:0 5px ;
  background:red;
  color:white;
  font-weight: bold;
  border-radius:6px;
}
</style>